module.exports = __webpack_public_path__ + "static/media/SG.2dd1a35f.svg";